export const BOOK_GENRES = [
  "fiction",
  "sci-fi",
  "romance",
  "fantasy",
  "historical",
  "mystery",
  "thriller",
  "horror",
  "comedy",
  "drama",
  "children",
  "poetry",
] as const

export type BookGenre = (typeof BOOK_GENRES)[number]

export const GENRE_BADGE_COLORS: Record<BookGenre, string> = {
  fiction: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  "sci-fi": "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300",
  romance: "bg-pink-100 text-pink-700 dark:bg-pink-900/40 dark:text-pink-300",
  fantasy: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
  historical: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  mystery: "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300",
  thriller: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  horror: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300",
  comedy: "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300",
  drama: "bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300",
  children: "bg-lime-100 text-lime-700 dark:bg-lime-900/40 dark:text-lime-300",
  poetry: "bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/40 dark:text-fuchsia-300",
}

export const GENRE_CHART_COLORS: Record<BookGenre, string> = {
  fiction: "#3b82f6",
  "sci-fi": "#6366f1",
  romance: "#ec4899",
  fantasy: "#a855f7",
  historical: "#f59e0b",
  mystery: "#6b7280",
  thriller: "#ef4444",
  horror: "#f97316",
  comedy: "#eab308",
  drama: "#14b8a6",
  children: "#84cc16",
  poetry: "#d946ef",
}
